import { Tooltip } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { GetCookieToken } from "../Cookie/GetCookie";
import { CheckPosition } from "../Function/CheckPosition";
import { CheckSubAdmin } from "../Function/CheckSubAdmin";

const subMenu = [
  {
    id: 1,
    icon: "fa-solid fa-clipboard",
    name: "กำหนดข้อมูลวันลา",
    path: "setdata?menuName=1",
  },
  // {
  // id:2,
  //   icon: <i className="fa-solid fa-user-shield font-size-20"></i>,

  //   name: "มอบหมายการปฏิบัติราชการ",
  //   path: "setdata?menuName=2",
  // },
  // {
  //   id: 3,
  //   icon: "fa-solid fa-calculator",
  //   name: "คำนวณวันลาสะสม",
  //   path: "setdata?menuName=3",
  // },
  // {
  //   id: 4,
  //   icon: "fa-solid fa-calendar-clock",
  //   name: "คำนวณวันทำงานย้อนหลัง",
  //   path: "setdata?menuName=4",
  // },
  {
    id: 5,
    icon: "fa-solid fa-calendar-image",
    name: "ปฏิทินวันหยุด",
    path: "setdata?menuName=5",
  },
  // {
  // id: 6,
  //   icon: <i className="fa-solid fa-users-gear font-size-20"></i>,

  //   name: "กำหนดสิทธิและบทบาท",
  //   path: "setdata?menuName=6",
  // },
];

const SubMenuLeave = ({ menu }) => {

  const baseURL = process.env.REACT_APP_API_CORS
  const token = GetCookieToken("userToken")
  const navigate = useNavigate();
  
  const [loading, setLoading] = useState(false);
  const [admin, setAdmin] = useState(false);
  const [userInfo, setUserInfo] = useState([])
  
  useEffect(() => {
    const getUserInfo = async () => {
      try {
        const res = await axios.get(baseURL + "/api/users/info", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUserInfo(res?.data?.result);
      } catch (err) {
        console.error(err);
      }
    };

    getUserInfo();
  }, []);

  useEffect(() => {
    setLoading(true)
    setAdmin(
      CheckSubAdmin(userInfo?.positionSubAdmin)
    );
    setTimeout(() => {
      setLoading(false)
    }, 1500);
  }, [userInfo]);
  
  return (
    <Row>
      <Col className="custom-menu">
        <Tooltip title="หน้าหลัก">
          <button
            className={
              !menu
                ? "rounded-pill btn btn-primary"
                : "rounded-pill btn btn-outline-primary"
            }
            onClick={() => {
              navigate(`/leave`);
            }}
          >
              <Row>
                <Col className="d-flex justify-content-center">
                    <i
                      className="fa-solid fa-house"
                      style={
                        {
                          paddingLeft: "0.1rem",
                          paddingRight: "0.1rem",
                        }
                      }
                    ></i>
                      {!menu && (
                        <Col lg={9}>
                          <FadeIn>
                            <span className="" 
                            // style={{ paddingRight: "1.8rem" }}
                            >
                              หน้าหลัก
                            </span>
                          </FadeIn>
                        </Col>
                      )}
                </Col>
              </Row>
          </button>
        </Tooltip>
        {subMenu &&
          subMenu?.map((item, idx) => {
            if (Number(menu) === Number(item?.id)) {
              return (
                <Tooltip key={idx} title={item?.name}>
                  <button
                    className={"rounded-pill btn btn-primary"}
                    onClick={() => {
                      navigate(`/leave/${item?.path}`);
                    }}
                  >
                      <Row>
                        <Col className="d-flex justify-content-center">
                            <i
                              className={item?.icon}
                              style={{
                                paddingLeft: "0.1rem",
                                paddingRight: "0.1rem",
                              }}
                            ></i>
                            {menu && (
                              <Col lg={9}>
                                <FadeIn>
                                  <span
                                    className="ps-1"
                                    style={{ paddingRight: "1.8rem", whiteSpace: "nowrap" }}
                                  >
                                    {item?.name}
                                  </span>
                                </FadeIn>
                              </Col>
                            )}
                        </Col>
                      </Row>
                  </button>
                </Tooltip>
              );
            } else {
              return (
                <Tooltip key={idx} title={item?.name}>
                  <button
                    className={"rounded-pill btn btn-outline-primary"}
                    onClick={() => {
                      navigate(`/leave/${item?.path}`);
                    }}
                  >
                    <Row>
                      <Col lg={2}>
                        <i
                          className={item?.icon}
                          style={{
                            paddingLeft: "0.1rem",
                            paddingRight: "0.1rem",
                          }}
                        ></i>
                      </Col>
                    </Row>
                  </button>
                </Tooltip>
              );
            }
          })}
      </Col>
    </Row>

  );
};

export default SubMenuLeave;
